import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VConsole from "vconsole";
var host = window.location.host;
window.isDev = host.indexOf("localhost") > -1 || host.indexOf("192.168") > -1;
if (isDev) {
  new VConsole();
}

import Horizontal from "./libs/horizontal";
require("./css/main.less");
Vue.config.productionTip = false;
// document.addEventListener(
//   "touchmove",
//   function(e) {
//     e.preventDefault();
//   },
//   false
// );
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
new Horizontal("#app");
